<div mat-dialog-title>
  <span>Select Address</span>
  <button matIconButton (click)="edit($event)">
    <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  @if (addresses.length>0) {
  <div class="addresses">
    @for (address of addresses; track $index) {
    <div class="address" (click)="select(address)">
      <mat-radio-button
        [checked]="address.id===selected?.id"
      ></mat-radio-button>
      <div class="inner">
        <h4>{{address.fname}} {{address.lname}}</h4>
        <p class="line">{{address.line1}}</p>
        @if (address.line2) {
        <p class="line">{{address.line2}}</p>
        }
        <p class="addr">
          {{address.city}}, {{address.state}}, {{address.postal_code}},
          {{address.country}}
        </p>
      </div>
      <button matIconButton (click)="edit($event, address)">
        <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
      </button>
    </div>
    }
  </div>
  }@else{
  <nz-empty nzNotFoundContent="No Address"></nz-empty>
  }
</div>

<div mat-dialog-actions align="end">
  <app-button (onClick)="close()">Cancel</app-button>
  <app-button type="filled" [loading]="loading" (onClick)="confirm()"
    >Select</app-button
  >
</div>
